import React, { useState } from "react";
import "./faq.css";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "How does The Pilot Guide actually help me prepare?",
      answer:
        "The Pilot Guide helps you prepare by letting you practice mock questions similar to those asked in CPL and type-rated airline written examinations, so you walk into the exam knowing what to expect.",
    },
    {
      question: "Can I practice the tests more than once?",
      answer:
        "Yes, absolutely. You get unlimited attempts — practice chapter-wise or full-length tests as many times as you need.",
    },
    {
      question: "How realistic are these mock exams?",
      answer:
        "The mocks are built to feel very close to the real CPL and airline written exams, in terms of pattern, difficulty, and question mix.",
    },
    {
      question: "Will I keep seeing the same questions again and again?",
      answer:
        "No. Every attempt gives you a fresh set of questions, randomly shuffled, so you’re actually learning — not memorising.",
    },
    {
      question: "Are explanations provided for the answers?",
      answer:
        "Yes. Every question comes with a clear explanation of the correct answer, so you understand the concept properly.",
    },
    {
      question: "What’s the difference between chapter-wise tests and the master quiz?",
      answer:
        "Chapter-wise tests help you strengthen one topic at a time, while the master quiz mixes questions from all chapters of the respective subject, just like a real exam.",
    },
    {
      question: "What else does The Pilot Guide offer apart from mock exams?",
      answer:
        "The Pilot Guide is an initiative by Right Source Aviation (RSA) and also supports students with CPL coaching, flight training, licence conversion, type rating, and airline preparation.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-5 bg-light faq-section">
      <div className="container">

        {/* TITLE */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">Frequently Asked Questions</h2>
        </div>

        {/* FAQ CARDS */}
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-card ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-header">
                <h6 className="mb-0">{faq.question}</h6>
                <span className="faq-icon">
                  <i
                    className={`fa-solid ${
                      activeIndex === index
                        ? "fa-chevron-up"
                        : "fa-chevron-down"
                    }`}
                  ></i>
                </span>
              </div>

              {activeIndex === index && (
                <div className="faq-body">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQ;
